<template>
    <div class="container">
        <van-nav-bar :title="isEdit ? '修改项目' : '添加项目'" left-arrow @click-left="onClickLeft" :fixed="true" />
        <div class="form">
            <van-form @submit="onSubmit">
                <van-field v-model="form.title" name="title" label="项目名称" clearable input-align="right"
                    placeholder="请填写项目名称" :rules="[{ required: true, message: '请填写项目名称' }]" />
                <van-field v-model="form.numbers" name="numbers" label="项目编号" clearable input-align="right"
                    placeholder="请输入项目编号" :rules="[{ required: true, message: '请输入项目编号' }]" />
                <van-field v-model="form.expertsPrice" name="expertsPrice" label="专家单人费" clearable input-align="right"
                    type="digit" placeholder="请输入专家单人费" :rules="[{ required: true, message: '请输入专家单人费' }]" />
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { getProjectDataApi, addProject, updateProject } from '@/api/projectList'
export default {
    data() {
        return {
            id: null,
            form: {
                title: '',
                numbers: '',
                expertsPrice: ''
            }
        }
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        },
        onSubmit(values) {
            Dialog.confirm({
                title: '提示',
                message: '请确认是否提交当前数据',
                cancelButtonText: '关闭',
                cancelButtonColor: '#fff',
                confirmButtonColor: '#2553E2',
                theme: 'round-button',
            })
                .then(() => {
                    let request = this.isEdit ? updateProject : addProject
                    request(this.form).then(res => {
                        Toast.success(res);
                        this.$router.go(-1);
                    }).catch(err => {
                        Toast.fail(err.message);
                    })
                })
                .catch(() => {
                    // on cancel
                });

        },
        getProjectData() {
            getProjectDataApi(this.id).then(res => {
                this.form = { ...res }
            }).catch(err => {
                Toast.fail(err.message);
            })
        }
    },
    created() {
        this.id = this.$route.query.id
        if (this.id) {
            this.getProjectData()
        }
    },
    computed: {
        isEdit() {
            return !!this.id
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    padding-top: 46px;
}

.van-nav-bar {
    :deep(.van-icon) {
        color: #000;
    }
}

:deep(.van-field__error-message) {
    display: none;
}
</style>